import 'babel-polyfill'
import React from 'react'
import { Router } from 'react-static'
import { hot } from 'react-hot-loader'
import Routes from 'react-static-routes'
import { Provider } from 'react-redux'

import store from 'connectors/redux'

import Header from 'components/Header'
import Footer from 'components/Footer'

import './stylesheets/local.scss'
import { ReportAlert } from './components/Header/ReportAlert'


class App extends React.Component {
    render() {
        return (
            <Provider store={store}>
                <Router>
                    <div className="layout">
                        <ReportAlert />
                        <Header />
                        <Routes />
                        <Footer />
                    </div>
                </Router>
            </Provider>
        )
    }
}

export default hot(module)(App)



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/App.js